import React, { useContext, useMemo } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import ProductConditions from '../product-conditions';
import { LegacyVariants } from '../product-variants/legacy-variants';
import { Variants } from '../product-variants';
import {
  Category,
  PriceListStatistics,
  VariantGroup,
  VariantValues,
} from 'src/types';
import { FiltersWrapper } from './styles';

const CATEGORY_SHOES = '1490';

export const ProductFilters: React.FC<IProductFilters> = props => {
  const { category, priceListStatistics, variantGroups, variants } = props;
  const { market } = useContext(AppContext);

  // ProductConditions should be visible if product has used offers.
  // ProductConditions should then continue to be visible, even if a selected variant has no conditions.
  // This is why it is wrapped in useMemo, to prevent the ProductConditions from being displayed and hidden back and forth in the UI when selecting variants.
  const showConditions = useMemo(
    () => Boolean((priceListStatistics?.used ?? 0) > 0),
    [priceListStatistics]
  );

  const hasLegacyVariants =
    variantGroups &&
    variantGroups.length > 0 &&
    market.productVariants?.legacySupportedCategories?.find(
      c => c === category?.id
    );

  const isInShoeCategory =
    category?.path?.length &&
    category?.path?.length >= 1 &&
    category.path[1]?.id === CATEGORY_SHOES;

  const hasShoeSizeVariants = variants && isInShoeCategory;

  return showConditions || hasLegacyVariants || hasShoeSizeVariants ? (
    <FiltersWrapper>
      {showConditions && (
        <ProductConditions priceListStatistics={priceListStatistics} />
      )}
      {hasLegacyVariants && <LegacyVariants variants={variantGroups!} />}
      {hasShoeSizeVariants && <Variants variants={variants!} />}
    </FiltersWrapper>
  ) : null;
};

interface IProductFilters {
  category?: Category | null;
  priceListStatistics?: PriceListStatistics;
  variantGroups?: VariantGroup[] | null; // Old variants from legacy
  variants?: VariantValues | null;
}
